<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-3">
      <div>
        <div class="d-flex align-center" style="gap: 6px">
          <h3 style="font-size: 16px; font-weight: 700; margin: 0; color: #0f3565">
            {{ $t('Equipamentos ativos por mês de criação') }}
          </h3>
          <v-tooltip color="white" bottom max-width="320">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="rgba(0,0,0,0.4)" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
            </template>
            <span class="black--text">
              <p class="mb-0 mt-2" style="font-size: 0.9rem">{{ $t('Apresenta a quantidade de equipamentos em cada um dos setores da instituição até a data limite filtrada, desconsiderando alienados e acessórios.') }}</p>
            </span>
          </v-tooltip>
        </div>
        <span v-if="total !== null" style="color: rgba(0,0,0,0.55); font-size: 12px">
          {{ $t('Total no período') }}: {{ total }}
        </span>
      </div>
    </div>

    <div v-if="loading" class="d-flex justify-center align-center" style="height: 300px">
      <v-progress-circular indeterminate color="#bbcf20" size="40" />
    </div>

    <div v-else-if="isEmpty" class="d-flex flex-column justify-center align-center" style="height: 300px">
      <v-icon color="rgba(0,0,0,0.2)" size="48">mdi-chart-bar</v-icon>
      <span style="color: rgba(0,0,0,0.4); font-size: 13px; margin-top: 8px">
        {{ $t('Nenhum dado encontrado') }}
      </span>
    </div>

    <v-chart
      v-else
      :option="chartOption"
      :autoresize="true"
      style="height: 320px; width: 100%"
    />
  </div>
</template>

<script>
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart } from 'echarts/charts'
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from 'echarts/components'
import ApiService from '../../../../services/ApiService'

use([CanvasRenderer, BarChart, TooltipComponent, GridComponent, LegendComponent])

export default {
  name: 'EquipmentByMonth',

  components: { VChart },

  props: {
    filterProp: { type: Object, default: () => ({}) },
  },

  data: () => ({
    loading: false,
    total: null,
    chartOption: {},
    apiService: new ApiService(),
  }),

  computed: {
    isEmpty() {
      return !this.chartOption.series || this.chartOption.series.length === 0
    },
  },

  watch: {
    filterProp: {
      handler() {
        this.load()
      },
      deep: true,
    },
  },

  created() {
    this.load()
  },

  methods: {
    async load() {
      this.loading = true
      try {
        const response = await this.apiService.post(
          'dashboardBI/equipment-by-month',
          this.filterProp
        )
        const { data, total } = response.content
        this.total = total
        this.buildChart(data || [])
      } catch (err) {
        // errors handled globally by ApiService
      } finally {
        this.loading = false
      }
    },

    buildChart(data) {
      this.chartOption = {
        animationDuration: 600,
        animationEasing: 'cubicOut',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(10,30,60,0.92)',
          borderColor: 'rgba(255,255,255,0.1)',
          textStyle: { color: '#fff', fontSize: 12 },
          axisPointer: { type: 'shadow' },
        },
        grid: { top: 16, right: 16, bottom: 32, left: 16, containLabel: true },
        xAxis: {
          type: 'category',
          data: data.map((d) => d.label),
          axisLabel: { color: 'rgba(0,0,0,0.6)', fontSize: 11 },
          axisLine: { lineStyle: { color: 'rgba(0,0,0,0.15)' } },
          splitLine: { show: false },
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: 'rgba(0,0,0,0.6)', fontSize: 11 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: 'rgba(0,0,0,0.08)' } },
        },
        series: [
          {
            type: 'bar',
            data: data.map((d) => d.count),
            barMaxWidth: 36,
            itemStyle: { color: '#bbcf20', borderRadius: [6, 6, 0, 0] },
            label: {
              show: true,
              position: 'top',
              color: 'rgba(0,0,0,0.65)',
              fontSize: 11,
              formatter: ({ value }) => (value > 0 ? value : ''),
            },
          },
        ],
      }
    },
  },
}
</script>
